import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  phoneNumber: string | null;
};

export const ContactPhoneCell = ({ phoneNumber }: Props) => {
  return <div className={desktopTruncateStyle}>{phoneNumber ?? '-'}</div>;
};
